import { render, staticRenderFns } from "./car-tech.vue?vue&type=template&id=1ddf2964"
import script from "./car-tech.vue?vue&type=script&lang=js"
export * from "./car-tech.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports